import { AlertTriangle } from "lucide-react";
import { CollapsibleSection } from "@/components/collapsible-section";
import { SimpleNoteTable } from "@/components/note-lists/simple-note-table";
import { useUpdateNoteMutation } from "@/mutations/notes";
import { useDeleteNoteWithUndo } from "@/hooks/useDeleteNoteWithUndo";
import type { Note } from "@/types/note";

interface OverdueSectionProps {
  notes: Note[];
  className?: string;
}

export function OverdueSection({ notes, className }: OverdueSectionProps) {
  const updateNoteMutation = useUpdateNoteMutation();
  const { deleteNote } = useDeleteNoteWithUndo();

  if (notes.length === 0) return null;

  const togglingNotes = new Set<string>();
  if (updateNoteMutation.isPending && updateNoteMutation.variables?.noteId) {
    togglingNotes.add(updateNoteMutation.variables.noteId);
  }

  const handleToggleComplete = (noteId: string, completed: boolean) => {
    updateNoteMutation.mutate({
      noteId,
      status: completed ? "COMPLETED" : "NOT_STARTED",
    });
  };

  const handleDelete = (noteId: string) => {
    const note = notes.find((n) => n.id === noteId);
    if (note) deleteNote(note);
  };

  return (
    <CollapsibleSection
      title="Overdue"
      icon={<AlertTriangle className="h-4 md:h-5 w-4 md:w-5" />}
      count={notes.length}
      className={className}
    >
      <div className="border-l-2 border-destructive pl-3">
        <SimpleNoteTable
          notes={notes}
          onToggleComplete={handleToggleComplete}
          onDelete={handleDelete}
          isTogglingComplete={togglingNotes}
        />
      </div>
    </CollapsibleSection>
  );
}
